import React from 'react';
import { Avatar } from '../common/Avatar';
import { TeamBadge } from '../common/TeamBadge';
import { MiniBars } from '../common/MiniBars';
import { MetricStrip } from '../common/MetricStrip';
import { formatDuration } from '../../utils/format';
import type { RankedRow } from '../CallsInsightHub/useCallsInsightHub';
const medals: Record<number, {
  card: string;
  badge: string;
  name: string;
}> = {
  1: {
    card: 'border-gold/30 bg-gold-soft',
    badge: 'bg-gold text-on-accent',
    name: 'Gold'
  },
  2: {
    card: 'border-silver/25 bg-silver-soft',
    badge: 'bg-silver text-on-accent',
    name: 'Silver'
  },
  3: {
    card: 'border-bronze/25 bg-bronze-soft',
    badge: 'bg-bronze text-on-accent',
    name: 'Bronze'
  }
};
interface PodiumCardProps {
  row: RankedRow;
  onSelect: (id: string) => void;
}
export function PodiumCard({
  row,
  onSelect
}: PodiumCardProps) {
  const {
    agent,
    stats,
    series,
    rank
  } = row;
  const medal = medals[rank] ?? medals[3];
  return <button type="button" onClick={() => onSelect(agent.id)} aria-label={`Rank ${rank}, ${agent.name}. View details`} className={`flex h-full w-full flex-col rounded-2xl border p-5 text-left shadow-card transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-lift active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${medal.card}`} data-id="element-417" data-mp="5ph93atpl636">
      <div className="flex w-full items-start justify-between gap-3" data-id="element-418" data-mp="byt08oxaqvue">
        <div className="flex min-w-0 items-center gap-3" data-id="element-419" data-mp="c0maee74by75">
          <Avatar name={agent.name} size="lg" data-id="element-420" data-mp="g165zdc1mtr6" />
          <div className="min-w-0" data-id="element-421" data-mp="g1y1ko5n4rhg">
            <p className="truncate font-semibold text-ink" data-id="element-422" data-mp="kyy8t2e880a5">{agent.name}</p>
            <div className="mt-1 flex flex-wrap items-center gap-2" data-id="element-423" data-mp="pyav9m16r5c7">
              <TeamBadge team={agent.team} data-id="element-424" data-mp="pzlz1lumsd3b" />
              <span className="text-xs text-muted" data-id="element-425" data-mp="1wewaumazlm1v">Ext. {agent.extension}</span>
            </div>
          </div>
        </div>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold ${medal.badge}`} title={`${medal.name} — rank ${rank}`} data-id="element-426" data-mp="21cejebl3dz9c">
          #{rank}
        </span>
      </div>

      <div className="mt-6 flex w-full items-end justify-between gap-4" data-id="element-427" data-mp="16sbtrpiaa8r8">
        <div data-id="element-428" data-mp="1lmzt0lx3caye">
          <p className="font-display text-[32px] font-bold leading-none tracking-tight text-ink" data-id="element-429" data-mp="1lmqatkiaf839">{formatDuration(stats.talkSeconds)}</p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-430" data-mp="sykpownbnh2w">Time on calls</p>
        </div>
        <div className="h-11 w-28" data-id="element-431" data-mp="swhuzzb84zru">
          <MiniBars data={series} label={`${agent.name} call activity`} data-id="element-432" data-mp="o0izlrrhahhx" />
        </div>
      </div>

      <div className="mt-5 w-full border-t border-ink/5 pt-4" data-id="element-433" data-mp="12ovtmj709q9s">
        <MetricStrip stats={stats} data-id="element-434" data-mp="xxxe3ltucw7l" />
      </div>
    </button>;
}